export const googleAuthConfig = {
  client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  redirect_uri: `${process.env.REACT_APP_FRONTEND_BASE_URL}/auth/callback`,
  scope: ["profile", "email"].join(" "),
};

// Debug logging
console.log("=== Auth Debug ===");
console.log("1. Environment Variables:");
console.log("FRONTEND_URL:", process.env.REACT_APP_FRONTEND_URL);
console.log("CLIENT_ID:", process.env.REACT_APP_GOOGLE_CLIENT_ID);
console.log("\n2. Full Auth Config:");
console.log(googleAuthConfig);
console.log(
  "\n3. Full Redirect URI:",
  `${process.env.REACT_APP_FRONTEND_URL}/auth/callback`
);
